import React, { useEffect } from "react"
import { Box, Typography } from "@mui/material"
import { dsColorNew } from '@palette'
import { dsRepricingDrawerData, dsRepricingDrawerErrors } from "Pages/DsRepricing/Page/@signals"
import { readPeriod, withPeriodField } from "Pages/DsRepricing/Page/@components/periodShape"
import RangeList from "Pages/DsRepricing/Page/@components/RangeList"

// Same shape as Duration: a list of windows instead of a single floor/ceiling pair. Both bounds
// are days before pickup, inclusive. 0 means the pickup day itself.
export default function DsRepricingLeadTimes({ active = true }) {
	const leadTimes = readPeriod(dsRepricingDrawerData.value).leadTimes
	// An inactive block publishes valid: the period mode above decides which of the three counts.
	const isValid = !active || leadTimes.length > 0

	useEffect(() => {
		dsRepricingDrawerErrors.value = { ...dsRepricingDrawerErrors.value, leadTimes: isValid }
	}, [isValid])

	return (
		<Box>
			<RangeList
				values={leadTimes}
				onChange={next => {
					dsRepricingDrawerData.value = withPeriodField(dsRepricingDrawerData.value, 'leadTimes', next)
				}}
				// The booking curve everyone actually splits on. A ladder
				// covers it end to end so a rule set has no gap; the
				// singles are for widening one that already exists.
				presets={{
					ladders: [
						{ label: 'Standard', ranges: [[0, 7], [8, 30], [31, 90], [91, 365]] },
						{ label: 'Near / far', ranges: [[0, 30], [31, 365]] },
					],
					singles: [[0, 3], [0, 7], [8, 30], [31, 90], [91, 365]],
				}}
				fromKey="leadFrom" toKey="leadTo"
				fromPlaceholder="3" toPlaceholder="7"
				minValue={0} maxValue={365}
				unitSuffix="days"
				addLabel="Add lead time"
				overlapsExisting={(existing, from, to) =>
					existing.some(w => from <= w.leadTo && w.leadFrom <= to)}
				overlapError="Overlaps with an existing lead time window"
				emptyError="Add at least one lead time window"
				showEmptyError={active}/>
			<Typography component="span" sx={{ fontSize: 12, color: dsColorNew.textMuted, display: 'block', mt: 0.75 }}>
				The rule applies on any date whose pickup falls inside one of these windows. Give last-minute
				windows a higher priority than the season rule they sit on top of.
			</Typography>
		</Box>
	)
}
